import { render } from "./UserGrid.vue?vue&type=template&id=7c2c216f"
import script from "./UserGrid.vue?vue&type=script&lang=js"
export * from "./UserGrid.vue?vue&type=script&lang=js"
script.render = render

export default script